<template>
  <div class="header">
    <div class="left-side">
      <h2>
        {{ name }}
      </h2>
      <breadcrumb />
    </div>
    <div class="right-side" v-if="buttons">
      <template v-for="(btn, index) in buttons" :key="index">
        <router-link
          v-if="btn.routeParams && !btn.disabled"
          class="btn"
          :class="btn.class"
          :data-step="btn.step || null"
          :to="btn.routeParams"
        >
          <span v-text="btn.label" />
          <i v-if="btn.icon" :class="btn.icon" />
        </router-link>
        <Button
          v-else
          :class="btn.class"
          :label="btn.label"
          :icon="btn.icon"
          :disabled="btn.disabled"
          @click="btn.click()"
        />
      </template>
    </div>
  </div>
</template>

<script setup>
import { reactive } from "vue";
import { copyToClipboard } from "@/composables/utils.js";

const state = reactive({
  copied: false,
});

function copy() {
  copyToClipboard(props.shareLink, false);
  state.copied = true;
  setTimeout(() => {
    state.copied = false;
  }, 2500);
}

const props = defineProps({
  name: {
    type: String,
  },
  shareLink: {
    type: String,
  },
  isPublic: {
    type: [String, null],
  },
  buttons: {
    type: Array,
  },
});
</script>
